import { NgModule } from '@angular/core';

// not used, only there to make ng-packagr happy
@NgModule({
    imports: [
    ],
    declarations: [],
    exports: []
})
export class XliffmergeModule { }
